export const EVENTS = {
    JOURNEY_STARTED: 'govt_id_journey_started',
    STEP_VIEWED: 'govt_id_step_viewed',
    ACTION_TAKEN: 'govt_id_action_taken',
    ISSUE_OCCURRED: 'govt_id_issue_occurred',
    JOURNEY_ENDED: 'govt_id_journey_ended',
    PAGE_LEFT: 'govt_id_page_left',
    READER_LOADED: 'document_reader_loaded',
    CAPTURE_STARTED: 'document_capture_started',
    CAPTURE_ENDED: 'document_capture_ended',
    SHOT_TAKEN: 'document_shot_taken',
    SCREENED: 'document_screened',
    SUBMITTED: 'document_submitted',
    VERDICT_SHOWN: 'document_verdict_shown',
    SELFIE_SESSION_STARTED: 'selfie_session_started',
    SELFIE_SESSION_ENDED: 'selfie_session_ended',
    SELFIE_VERDICT_SHOWN: 'selfie_verdict_shown',
};

export const STEPS = {
    INSTRUCTIONS: 'instructions',
    CAMERA: 'camera',
    BETWEEN_SIDES: 'between_sides',
    CONFIRM: 'confirm',
    ANALYSING: 'analysing',
    SELFIE_INSTRUCTIONS: 'selfie_instructions',
    SELFIE_CAMERA: 'selfie_camera',
    SELFIE_ANALYSING: 'selfie_analysing',
    RESULT: 'result',
    ERROR: 'error',
    TIMEOUT: 'timeout',
    ATTEMPTS_EXHAUSTED: 'attempts_exhausted',
};

export const ACTIONS = {
    CAPTURE_TAPPED: 'capture_tapped',
    MODE_CHANGED: 'mode_changed',
    GUIDE_OPENED: 'guide_opened',
    CAMERA_CLOSED: 'camera_closed',
    RETRY_TAPPED: 'retry_tapped',
    CONTINUE_TAPPED: 'continue_tapped',
    CAPTURE_NEXT_TAPPED: 'capture_next_tapped',
    TRY_AGAIN_TAPPED: 'try_again_tapped',
    SELFIE_CANCELLED: 'selfie_cancelled',
};

// Where a capture_tapped came from.
export const CAPTURE_SOURCES = {
    INSTRUCTIONS: 'instructions',
    QUALITY_GUIDANCE: 'quality_guidance',
    MODE_GUIDANCE: 'mode_guidance',
    DIFFERENT_ID_GUIDANCE: 'different_id_guidance',
};

export const ISSUE_CATEGORIES = {
    SDK_ERROR: 'sdk_error',
    CAMERA_ERROR: 'camera_error',
    CAPTURE_REFUSED: 'capture_refused',
    CAPTURE_TIMEOUT: 'capture_timeout',
    VERDICT_FAILED: 'verdict_failed',
    WARNING_SHOWN: 'warning_shown',
    NETWORK: 'network',
    SESSION_TIMEOUT: 'session_timeout',
    UNSUPPORTED_DEVICE: 'unsupported_device',
    VERDICT_TIMEOUT: 'verdict_timeout',
};

export const READER_OUTCOMES = {
    READY: 'ready',
    FAILED: 'failed',
    CANCELLED: 'cancelled',
};

export const CAPTURE_OUTCOMES = {
    CAPTURED: 'captured',
    PAGE_NEEDED: 'page_needed',
    CLOSED: 'closed',
    TIMED_OUT: 'timed_out',
    CAMERA_ERROR: 'camera_error',
    SDK_ERROR: 'sdk_error',
    INTERRUPTED: 'interrupted',
};

export const SUBMIT_OUTCOMES = {
    OK: 'ok',
    FAILED: 'failed',
};

export const SUBMIT_STEPS = {
    FINALIZE: 'finalize',
    SUBMIT: 'submit',
};

export const VERDICT_OUTCOMES = {
    PASSED: 'passed',
    FAILED: 'failed',
    TIMED_OUT: 'timed_out',
    ERROR: 'error',
};

export const SELFIE_SESSION_OUTCOMES = {
    ANALYSED: 'analysed',
    CANCELLED: 'cancelled',
    TIMED_OUT: 'timed_out',
    CAMERA_ERROR: 'camera_error',
    RUNTIME_ERROR: 'runtime_error',
    FACE_REJECTED: 'face_rejected',
    CREATE_FAILED: 'create_failed',
    LANDSCAPE: 'landscape',
    INTERRUPTED: 'interrupted',
};

export const SELFIE_VERDICT_OUTCOMES = {
    PASSED: 'passed',
    FAILED: 'failed',
    ERROR: 'error',
};

export const SELFIE_REASONS = {
    NOT_LIVE: 'not_live',
    NO_FACE_MATCH: 'no_face_match',
    NOT_LIVE_AND_NO_FACE_MATCH: 'not_live_and_no_face_match',
    UNKNOWN: 'unknown',
};

export const SEVERITY = {
    BLOCKING: 'blocking',
    RECOVERABLE: 'recoverable',
};

export const FINAL_STATUS = {
    PASSED: 'passed',
    SELFIE_FAILED: 'selfie_failed',
    DOCUMENT_FAILED: 'document_failed',
    NOT_ACCEPTED: 'not_accepted',
};

export const SELFIE_OUTCOME = {
    PASSED: 'passed',
    FAILED: 'failed',
};

export const COUNTERS = {
    CAPTURES: 'captures',
    SHOTS: 'shots',
    SELFIE_SESSIONS: 'selfie_sessions',
};
